import { defineStore } from 'pinia'

export const useRewardStore = defineStore('reward', {
  state: () => ({
    rewardAmount: {
      reward: 0,
      rewardBound: 0
    },
    countdownSeconds: 0,
    status: null, // 状态 0未领取 1已领取 2已过期
    minShowReward: 0, // 低奖励范围
    maxShowReward: 0 // 高奖励范围
  }),

  actions: {
    setRewardData(amount: { reward: number, rewardBound: number }, countdown: number) {
      console.log('setRewardData 接收到的参数:', { amount, countdown })
      this.rewardAmount = amount
      this.countdownSeconds = countdown
      // 保存到localStorage
      this.saveToStorage()
    },

    updateCountdown(seconds: number) {
      this.countdownSeconds = seconds
      // 保存到localStorage
      this.saveToStorage()
    },

    // 设置新用户专属奖励数据
    setNewUserExclusiveData(data: any) {
      console.log('setNewUserExclusiveData 接收到的参数:', data)
      // 检查数据是否有效
      if (!data) {
        console.warn('setNewUserExclusiveData: 数据为空，跳过设置 ')
        return
      }

      this.status = data.status
      this.minShowReward = data.minShowReward
      this.maxShowReward = data.maxShowReward
      this.rewardAmount = {
        reward: 0,
        rewardBound: data.rewardAmount
      }
      this.countdownSeconds = data.expiredTime || 0
      // 保存到localStorage
      this.saveToStorage()
    },

    // 保存到localStorage
    saveToStorage() {
      localStorage.setItem('rewardData', JSON.stringify({
        rewardAmount: this.rewardAmount,
        countdownSeconds: this.countdownSeconds,
        status: this.status,
        minShowReward: this.minShowReward,
        maxShowReward: this.maxShowReward
      }))
    },

    // 从localStorage加载
    loadFromStorage() {
      try {
        const saved = localStorage.getItem('rewardData')
        if (saved) {
          const data = JSON.parse(saved)
          this.rewardAmount = data.rewardAmount || {
            reward: 0,
            rewardBound: 0
          }
          this.countdownSeconds = data.countdownSeconds || 0
          this.status = data.status
          this.minShowReward = data.minShowReward || 0
          this.maxShowReward = data.maxShowReward || 0
        }
      } catch (error) {
        console.error('加载奖励数据失败:', error)
      }
    },

    // 清除数据
    clearData() {
      this.rewardAmount = {
        reward: 0,
        rewardBound: 0
      }
      this.countdownSeconds = 0
      this.status = null
      this.minShowReward = 0
      this.maxShowReward = 0
      localStorage.removeItem('rewardData')
    }
  }
})
